import { useContext } from "react";
import Form from "react-bootstrap/Form";
import { QuestionProps } from "./Props";

import InterfaceContext from "../Context";
import { useModularMarkdown } from "../Hooks/ModularMarkdown";
import { useLocalizedStrings } from "../Localization";
import { languageContent } from "../Util";


export function ConfirmQuestion(props: QuestionProps) {
  const context = useContext(InterfaceContext);
  const L = useLocalizedStrings();

  const name = props["Target Field"]!;
  const value = props["Value"] || "yes";

  const content = props[languageContent(context.lang)]?.replace("\\(", "(").replace("\\[", "[") || '';

  // Make sure all asterisks (**) for boldness are snug up next to the next they need to be next to.
  // Also, make sure all underscores (_) for italics are snug up next to the next they need to be next to.
  const marked = useModularMarkdown({
    content,
    info: props.info,
    replacer: (str) => str.replace(' **\n', '**\n').replace('^** ', '**')
  });

  function isChecked() {
    return (props.info[props["Target Field"]!] || "") === value;
  }

  function setChecked(checked: boolean) {
    props.setInfoKey(props["Target Field"]!, checked ? value : "", true, false);
  }

  if ((props["Additional Options"] || []).indexOf("Hidden") !== -1) {
    return <span></span>
  }

  // TODO: replace with component library checkbox to fix RTL language spacing issue
  return (
    <fieldset>
      <legend>
        {marked}
      </legend>
      <Form.Group>
        <Form.Check
          className="pr-2"
          checked={isChecked()}
          onChange={(e: any) => setChecked(e.target.checked)}
          type="checkbox"
          name={name}
          id={props['Target Field']}
          label={
            <div className="pr-6">
              {L.questions.choice.yes}
            </div>
          }
        />
      </Form.Group>
    </fieldset>
  );
}